import cn from 'clsx';
import React from 'react';
import { useNavigate } from 'react-router';

import { rootRoutes } from '../../../app/routers/rootRoutes';
import { ReactComponent as GoBack } from '../../../shared/assets/arrowLeft.svg';
import styles from './Header.module.css';

type Props = {
  children?: React.ReactNode[] | React.ReactNode;
  leftIcon?: React.ReactNode;
  goBackLink?: string;
  rightIcon?: React.ReactNode;
};

export const Header: React.FC<Props> = ({ children, goBackLink, leftIcon, rightIcon }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(goBackLink ?? rootRoutes.taskList);
  };

  return (
    <header className={styles.root} data-id="header">
      <span className={cn(styles.icon, styles.leftIcon)} data-id="leftBtn">
        {leftIcon ?? <GoBack data-id="goBackIcon" onClick={handleClick} />}
      </span>

      <span className={styles.title} data-id="title">
        {children}
      </span>

      {rightIcon ? (
        <span className={cn(styles.icon, styles.rightIcon)} data-id="rightBtn">
          {rightIcon}
        </span>
      ) : null}
    </header>
  );
};
